export const ACTION_TYPES = {
  CLEANING_REQUEST_START: 'CLEANING_REQUEST_START',
  CLEANING_REQUEST_END: 'CLEANING_REQUEST_END',
  FETCH_CLEANING_QA_LIST_SUCCESS: 'FETCH_CLEANING_QA_LIST_SUCCESS',
  FETCH_CLEANING_HISTORY_LIST_SUCCESS: 'FETCH_CLEANING_HISTORY_LIST_SUCCESS',
  FETCH_CLEANING_DETAIL_SUCCESS: 'FETCH_CLEANING_DETAIL_SUCCESS',
  FETCH_TRAINING_TUTORIALS_SUCCESS: 'FETCH_TRAINING_TUTORIALS_SUCCESS',
};
